import { useAppSelector } from '@/redux/hooks/useAppState'
import { versionSelector } from '@/redux/store/slices/grid/gridSlice'
import { useMemo } from 'react'

import type { AggregatedDemographics } from 'honeygrid-types'

export const useTargetingSelection = (aggregatedDemographics?: AggregatedDemographics) => {
	const draftVersion = useAppSelector(versionSelector)
	const targetingFilters = draftVersion?.targeting_filters

	const targetingSelection = useMemo(() => {
		const set = new Set<string>()
		if (!targetingFilters || !aggregatedDemographics?.sortedCellIds) return [...set]

		const totalCells = Object.keys(aggregatedDemographics.cells ?? {}).length

		for (const [key, value] of Object.entries(targetingFilters)) {
			// We store percentage as a whole number to avoid floating point errors
			// So we need to divide the percentage by 100 to get the actual percentage
			const numberOfCells = aggregatedDemographics.sortedCellIds[key]
				? aggregatedDemographics.sortedCellIds[key].length
				: totalCells
			const selectionIndex = Math.floor(((value?.percentage ?? 0) * numberOfCells) / 100)
			const cellIds = aggregatedDemographics.sortedCellIds[key]?.slice(0, selectionIndex)

			if (!cellIds) continue

			for (const id of cellIds) {
				set.add(id)
			}
		}

		return [...set]
	}, [targetingFilters, aggregatedDemographics])

	return targetingSelection
}
